import "./Home.css";
import { useNavigate } from "react-router-dom";

function Home() {
  const navigate = useNavigate();

  const handleEstimationClick = (e) => {
    e.preventDefault();
    navigate("/quote");
    setTimeout(() => {
      const section = document.getElementById("estimation");
      if (section) section.scrollIntoView({ behavior: "smooth" });
    }, 100);
  };

  return (
    <section className="hero-page" id="home">
      <div className="hero-content">
        <h1>Sarrathi Constructions</h1>

        <p className="hero-copy">
          Specializing in residential, commercial, and industrial developments,
          we combine experience with exceptional craftsmanship. Every project
          reflects our dedication to quality, innovation, and attention to
          detail. We build spaces that create lasting value and inspire
          confidence.
        </p>

        <div className="hero-actions">
          <a
            href="/"
            className="primary-action"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById("projects")?.scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
            }}
          >
            View projects
          </a>

          <a
            className="secondary-action"
            href="/quote#estimation"
            onClick={handleEstimationClick}
          >
            Get Your Free Estimation
          </a>
        </div>
      </div>
    </section>
  );
}

export default Home;
